// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__7n5Ky"};